// Fallback data for when API calls fail
// Add this import at the top
import testImage from '../../../assets/test.png';

// Then use it like this:

export const fallbackAgents = {
  count: 8,
  next: null,
  previous: null,
  results: [
    {
      id: 'agent-1',
      info: {
        id: 'info-1',
        name: 'Customer Support AI',
        short_description:
          'Intelligent customer service assistant with sentiment analysis',
        long_description:
          'Advanced AI assistant for customer support with real-time sentiment analysis and multi-language support.',
        tags: ['support', 'nlp', 'automation'],
        assistant: 'agent-1',
        image: testImage,
        n_purchases: 2847,
      },
      author: {
        id: 'author-1',
        username: 'Sarah Chen',
        image: null,
      },
      current_public_version: {
        id: 'version-1',
        version: '2.1.0',
        features: 'Sentiment analysis, Multi-language support',
      },
      created_at: '2025-01-15T10:00:00.000Z',
      updated_at: '2025-01-20T15:30:00.000Z',
    },
    {
      id: 'agent-2',
      info: {
        id: 'info-2',
        name: 'Data Pipeline Agent',
        short_description: 'ETL workflows with real-time data processing',
        long_description:
          'Powerful data pipeline agent for ETL operations with real-time processing capabilities.',
        tags: ['data', 'etl', 'analytics'],
        assistant: 'agent-2',
        image: null,
        n_purchases: 1923,
      },
      author: {
        id: 'author-2',
        username: 'Mike Johnson',
        image: null,
      },
      current_public_version: {
        id: 'version-2',
        version: '1.5.2',
        features: 'Real-time processing, Data validation',
      },
      created_at: '2025-01-10T09:00:00.000Z',
      updated_at: '2025-01-18T14:20:00.000Z',
    },
    {
      id: 'agent-3',
      info: {
        id: 'info-3',
        name: 'Social Media Manager',
        short_description:
          'Schedule and analyze social media posts across platforms',
        long_description:
          'Comprehensive social media management tool with scheduling and analytics.',
        tags: ['social', 'marketing', 'scheduling'],
        assistant: 'agent-3',
        image: null,
        n_purchases: 3156,
      },
      author: {
        id: 'author-3',
        username: 'Emma Wilson',
        image: null,
      },
      current_public_version: {
        id: 'version-3',
        version: '3.0.1',
        features: 'Multi-platform support, Analytics dashboard',
      },
      created_at: '2025-01-05T08:00:00.000Z',
      updated_at: '2025-01-19T16:45:00.000Z',
    },
    {
      id: 'agent-4',
      info: {
        id: 'info-4',
        name: 'Code Review Assistant',
        short_description:
          'Automated code review with best practices enforcement',
        long_description:
          'AI-powered code review assistant that enforces best practices and coding standards.',
        tags: ['development', 'review', 'quality'],
        assistant: 'agent-4',
        image: null,
        n_purchases: 1567,
      },
      author: {
        id: 'author-4',
        username: 'Alex Kumar',
        image: null,
      },
      current_public_version: {
        id: 'version-4',
        version: '1.2.0',
        features: 'Best practices enforcement, Security scanning',
      },
      created_at: '2025-01-12T11:00:00.000Z',
      updated_at: '2025-01-17T13:15:00.000Z',
    },
    {
      id: 'agent-5',
      info: {
        id: 'info-5',
        name: 'SEO Optimizer',
        short_description: 'Optimize content for search engines automatically',
        long_description:
          'Advanced SEO optimization tool with keyword analysis and content suggestions.',
        tags: ['seo', 'marketing', 'content'],
        assistant: 'agent-5',
        image: null,
        n_purchases: 892,
      },
      author: {
        id: 'author-5',
        username: 'Lisa Park',
        image: null,
      },
      current_public_version: {
        id: 'version-5',
        version: '1.8.3',
        features: 'Keyword analysis, Content optimization',
      },
      created_at: '2025-01-08T10:30:00.000Z',
      updated_at: '2025-01-16T12:00:00.000Z',
    },
    {
      id: 'agent-6',
      info: {
        id: 'info-6',
        name: 'Email Campaign Manager',
        short_description: 'Create and manage email marketing campaigns',
        long_description:
          'Complete email marketing solution with templates and analytics.',
        tags: ['email', 'marketing', 'automation'],
        assistant: 'agent-6',
        image: null,
        n_purchases: 1234,
      },
      author: {
        id: 'author-6',
        username: 'Tom Davis',
        image: null,
      },
      current_public_version: {
        id: 'version-6',
        version: '2.3.1',
        features: 'Template library, A/B testing',
      },
      created_at: '2025-01-06T09:15:00.000Z',
      updated_at: '2025-01-14T11:30:00.000Z',
    },
    {
      id: 'agent-7',
      info: {
        id: 'info-7',
        name: 'Translation Assistant',
        short_description: 'Real-time translation for 50+ languages',
        long_description:
          'Professional translation assistant supporting over 50 languages with context awareness.',
        tags: ['translation', 'language', 'communication'],
        assistant: 'agent-7',
        image: null,
        n_purchases: 2156,
      },
      author: {
        id: 'author-7',
        username: 'Maria Garcia',
        image: null,
      },
      current_public_version: {
        id: 'version-7',
        version: '1.9.0',
        features: '50+ languages, Context awareness',
      },
      created_at: '2025-01-03T08:45:00.000Z',
      updated_at: '2025-01-13T10:20:00.000Z',
    },
    {
      id: 'agent-8',
      info: {
        id: 'info-8',
        name: 'Project Manager AI',
        short_description: 'Automated project management and task tracking',
        long_description:
          'Intelligent project management assistant with automated task tracking and reporting.',
        tags: ['project', 'management', 'productivity'],
        assistant: 'agent-8',
        image: null,
        n_purchases: 1789,
      },
      author: {
        id: 'author-8',
        username: 'David Lee',
        image: null,
      },
      current_public_version: {
        id: 'version-8',
        version: '2.5.0',
        features: 'Task automation, Progress tracking',
      },
      created_at: '2025-01-01T07:00:00.000Z',
      updated_at: '2025-01-11T09:00:00.000Z',
    },
  ],
};

export const fallbackPrograms = {
  count: 10,
  next: null,
  previous: null,
  results: [
    {
      id: 'prog-1',
      author: {
        id: 'author-1',
        username: 'MindMade',
        image: null,
      },
      current_public_version: {
        id: 'prog-version-1',
        version: '1.0.0',
        is_public: true,
        is_enabled: true,
        created_at: '2025-01-01T12:00:00.000Z',
        description: 'Initial release',
        updated_at: '2025-01-01T12:00:00.000Z',
        features: '',
        program: 'prog-1',
        environment: 'env-1',
        previous_version: null,
      },
      program_type: 'INTEGRATION',
      title: 'Slack Integration',
      short_description: 'Send messages and manage channels',
      long_description:
        'Complete Slack integration for messaging and channel management.',
      image: testImage,
      n_purchases: 5234,
      created_at: '2025-01-01T12:00:00.000Z',
      updated_at: '2025-01-15T14:00:00.000Z',
    },
    {
      id: 'prog-2',
      author: {
        id: 'author-1',
        username: 'MindMade',
        image: null,
      },
      current_public_version: {
        id: 'prog-version-2',
        version: '2.0.0',
        is_public: true,
        is_enabled: true,
        created_at: '2025-01-02T12:00:00.000Z',
        description: 'Enhanced features',
        updated_at: '2025-01-10T12:00:00.000Z',
        features: '',
        program: 'prog-2',
        environment: 'env-2',
        previous_version: null,
      },
      program_type: 'AI_ML',
      title: 'OpenAI GPT-4',
      short_description: 'Advanced language model integration',
      long_description:
        "Integrate OpenAI's GPT-4 for advanced text generation.",
      image: null,
      n_purchases: 8921,
      created_at: '2025-01-02T12:00:00.000Z',
      updated_at: '2025-01-18T15:00:00.000Z',
    },
    {
      id: 'prog-3',
      author: {
        id: 'author-1',
        username: 'MindMade',
        image: null,
      },
      current_public_version: {
        id: 'prog-version-3',
        version: '1.5.0',
        is_public: true,
        is_enabled: true,
        created_at: '2025-01-03T12:00:00.000Z',
        description: 'Performance improvements',
        updated_at: '2025-01-12T12:00:00.000Z',
        features: '',
        program: 'prog-3',
        environment: 'env-3',
        previous_version: null,
      },
      program_type: 'DATABASE',
      title: 'PostgreSQL Connector',
      short_description: 'Database operations and queries',
      long_description:
        'Full PostgreSQL database connector with query builder.',
      image: null,
      n_purchases: 3456,
      created_at: '2025-01-03T12:00:00.000Z',
      updated_at: '2025-01-16T13:00:00.000Z',
    },
    {
      id: 'prog-4',
      author: {
        id: 'author-1',
        username: 'MindMade',
        image: '../../../assets/test.png',
      },
      current_public_version: {
        id: 'prog-version-4',
        version: '1.2.0',
        is_public: true,
        is_enabled: true,
        created_at: '2025-01-04T12:00:00.000Z',
        description: 'Bug fixes',
        updated_at: '2025-01-08T12:00:00.000Z',
        features: '',
        program: 'prog-4',
        environment: 'env-4',
        previous_version: null,
      },
      program_type: 'FINANCE',
      title: 'Stripe Payments',
      short_description: 'Process payments and subscriptions',
      long_description: 'Complete Stripe integration for payment processing.',
      image: null,
      n_purchases: 2789,
      created_at: '2025-01-04T12:00:00.000Z',
      updated_at: '2025-01-14T11:00:00.000Z',
    },
    {
      id: 'prog-5',
      author: {
        id: 'author-1',
        username: 'MindMade',
        image: null,
      },
      current_public_version: {
        id: 'prog-version-5',
        version: '1.8.0',
        is_public: true,
        is_enabled: true,
        created_at: '2025-01-05T12:00:00.000Z',
        description: 'New features added',
        updated_at: '2025-01-09T12:00:00.000Z',
        features: '',
        program: 'prog-5',
        environment: 'env-5',
        previous_version: null,
      },
      program_type: 'COMMUNICATION',
      title: 'SendGrid Email',
      short_description: 'Transactional email service',
      long_description: 'SendGrid integration for transactional emails.',
      image: null,
      n_purchases: 4123,
      created_at: '2025-01-05T12:00:00.000Z',
      updated_at: '2025-01-17T16:00:00.000Z',
    },
    {
      id: 'prog-6',
      author: {
        id: 'author-1',
        username: 'MindMade',
        image: null,
      },
      current_public_version: {
        id: 'prog-version-6',
        version: '2.1.0',
        is_public: true,
        is_enabled: true,
        created_at: '2025-01-06T12:00:00.000Z',
        description: 'Major update',
        updated_at: '2025-01-11T12:00:00.000Z',
        features: '',
        program: 'prog-6',
        environment: 'env-6',
        previous_version: null,
      },
      program_type: 'DEVELOPMENT',
      title: 'GitHub API',
      short_description: 'Repository and issue management',
      long_description:
        'Complete GitHub API integration for repository management.',
      image: null,
      n_purchases: 6789,
      created_at: '2025-01-06T12:00:00.000Z',
      updated_at: '2025-01-19T17:00:00.000Z',
    },
  ],
};

export const fallbackHotAgents = [
  {
    id: 'hot-agent-1',
    info: {
      id: 'hot-info-1',
      name: 'AI Content Creator',
      short_description:
        'Generate high-quality content with advanced AI models',
      long_description:
        'Professional content creation assistant powered by the latest AI technology.',
      tags: ['content', 'ai', 'writing'],
      assistant: 'hot-agent-1',
      image: testImage,
      n_purchases: 5567,
    },
    author: {
      id: 'hot-author-1',
      username: 'TechLabs',
      image: testImage,
    },
    current_public_version: {
      id: 'hot-version-1',
      version: '3.2.1',
      features: 'Multi-format content generation',
    },
    created_at: '2025-01-10T10:00:00.000Z',
    updated_at: '2025-01-20T18:00:00.000Z',
  },
  {
    id: 'hot-agent-2',
    info: {
      id: 'hot-info-2',
      name: 'Smart Analytics',
      short_description: 'Real-time data analytics and visualization',
      long_description:
        'Advanced analytics platform with real-time data processing and visualization.',
      tags: ['analytics', 'data', 'visualization'],
      assistant: 'hot-agent-2',
      image: null,
      n_purchases: 13892,
    },
    author: {
      id: 'hot-author-2',
      username: 'DataPro',
      image: null,
    },
    current_public_version: {
      id: 'hot-version-2',
      version: '2.8.0',
      features: 'Real-time dashboards',
    },
    created_at: '2025-01-08T09:00:00.000Z',
    updated_at: '2025-01-19T16:00:00.000Z',
  },
  {
    id: 'hot-agent-3',
    info: {
      id: 'hot-info-3',
      name: 'DevOps Assistant',
      short_description: 'Automate your DevOps workflows',
      long_description:
        'Complete DevOps automation assistant for CI/CD pipelines.',
      tags: ['devops', 'automation', 'deployment'],
      assistant: 'hot-agent-3',
      image: null,
      n_purchases: 2734,
    },
    author: {
      id: 'hot-author-3',
      username: 'CloudOps',
      image: null,
    },
    current_public_version: {
      id: 'hot-version-3',
      version: '1.9.5',
      features: 'Pipeline automation',
    },
    created_at: '2025-01-05T08:00:00.000Z',
    updated_at: '2025-01-18T14:00:00.000Z',
  },
];
